import '../styles/landing-fix.scss';
import cx from 'classnames';
import { PureComponent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { AA } from '@mono/shared';
import appleStoreImg from '../../assets/img/apple-store.png';
import androidStoreImg from '../../assets/img/ch-play.png';
import mobileAppImg from '../../assets/img/phone.png';
import zimidyLogoImg from '../../assets/img/zimidy-logo.png';
import styles from '../styles/landing.module.scss';

export default class Landing extends PureComponent<
  AA,
  {
    showMenu: boolean;
  }
> {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
    };
  }

  // handle toggle
  toggleMenu = () => {
    const { showMenu } = this.state;

    this.setState({
      showMenu: !showMenu,
    });
  };

  override render() {
    const { showMenu } = this.state;

    return (
      <div className={cx(styles.landing)}>
        <div className={cx(styles.banner)}>
          <nav className={cx(styles.navbar, 'navbar', 'navbar-expand-lg ')}>
            <div className="container">
              <a className={cx(styles.navbarBrand, 'navbar-brand ')} href="/">
                <img src={zimidyLogoImg} alt="Zimily-logo" className={cx(styles.imgLogo)} />
              </a>
              <div className={cx(styles.navbarCollapse, styles.collapse, 'navbar-collapse')}>
                <div
                  className={cx(styles.navToggle, {
                    [styles.active]: showMenu,
                  })}
                  onClick={this.toggleMenu}
                >
                  <div className={cx(styles.bar, styles.top)} />
                  <div className={cx(styles.bar, styles.middle)} />
                  <div className={cx(styles.bar, styles.bottom)} />
                </div>
                <ul
                  className={cx(
                    styles.navbarNav,
                    {
                      [styles.active]: showMenu,
                    },
                    'navbar-nav',
                  )}
                >
                  <li className={cx(styles.navItem, 'nav-item')}>
                    <a className={cx(styles.navLink, 'nav-link')} href="#">
                      How Zimidy works
                    </a>
                  </li>
                  <li className={cx(styles.navItem, 'nav-item')}>
                    <a className={cx(styles.navLink, 'nav-link')} href="#">
                      Features
                    </a>
                  </li>
                  <li className={cx(styles.navItem, 'nav-item')}>
                    <a className={cx(styles.navLink, 'nav-link')} href="#">
                      Download
                    </a>
                  </li>
                </ul>
                <div
                  className={cx(styles.overlay, {
                    [styles.active]: showMenu,
                  })}
                  onClick={this.toggleMenu}
                />
              </div>
            </div>
          </nav>

          <div className={cx(styles.introduce)}>
            <div className="container">
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} className="convert">
                  <div className={cx(styles.mobile)}>
                    <img
                      src={mobileAppImg}
                      alt="mobileapp"
                      className={cx(styles.mobileapp, 'img-fluid')}
                    />
                  </div>
                  <div className={cx(styles.desc, 'text-center')}>
                    <div className={cx(styles.text)}>
                      <p>
                        Our friends already know how cool you are, now show the world, on Zimidy.
                        Get Together, Hangout, Meet People and let everyone see how amazing you are.
                      </p>
                    </div>
                    <div className={cx(styles.app)}>
                      <p className={cx(styles.text)}>available in app stores</p>
                      <a href="#" className={cx(styles.link, 'ios')} type="">
                        <img src={appleStoreImg} alt="app-store" className={cx(styles.imgapp)} />
                      </a>
                      <a href="#" className={cx(styles.link, 'androi')} type="">
                        <img src={androidStoreImg} alt="ch-play" className={cx(styles.imgapp)} />
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className={cx(styles.features)}>
          <div className="container">
            <Row className={styles.mr0}>
              <div className={cx(styles.info, 'text-center')}>
                <h2 className={cx(styles.title)}>It’s almost too easy!</h2>
                <div className={cx(styles.desc)}>
                  Download the app. If you like what you see, join. If you don&apos;t, create
                  something. If none of that works, find local people to think of something
                  together! It doesn&apos;t get simpler. If simplifying your social life can&apos;t
                  convince you, here are a few more reasons to get started, today!
                </div>
              </div>
              <Col xs={12} sm={6} md={3} lg={3}>
                <div className={cx(styles.card)}>
                  <div className={cx(styles.featuresImg)}>
                    <span className={cx(styles.icon, styles.iconPayment)} />
                  </div>
                  <div className={cx(styles.cardBody, 'card-body')}>
                    <h3 className={cx(styles.cardTitle, ' card-title text-center')}>PAYMENTS</h3>
                    <p className={cx(styles.cardText, 'card-text')}>
                      Organizing cool things to do with your friends is fun! Getting them to pay you
                      back, is not. We solved that. Zimidy partner&apos;s with stripe so you can
                      charge them up front.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} lg={3}>
                <div className={cx(styles.card, styles.cardBlue)}>
                  <div className={cx(styles.featuresImg)}>
                    <span className={cx(styles.icon, styles.iconHangout)} />
                  </div>
                  <div className={cx(styles.cardBody, 'card-body')}>
                    <h3 className={cx(styles.cardTitle, ' card-title text-center')}>HANGOUT</h3>
                    <p className={cx(styles.cardText, 'card-text')}>
                      You can hang out with friends or find new things to do in your local area by
                      searching on Zimidy for whats happening around you, right now. You’ll
                      definitely find something worth joining!
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} lg={3}>
                <div className={cx(styles.card)}>
                  <div className={cx(styles.featuresImg)}>
                    <span className={cx(styles.icon, styles.iconPoints)} />
                  </div>
                  <div className={cx(styles.cardBody, 'card-body')}>
                    <h3 className={cx(styles.cardTitle, ' card-title text-center')}>POINTS</h3>
                    <p className={cx(styles.cardText, 'card-text')}>
                      Where else can you go to get rewarded every time you have fun or meet new
                      people. Nowhere. We&apos;re giving you points to say thanks for being a great
                      member of the Zimidy community.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} lg={3}>
                <div className={cx(styles.card, styles.cardBlue)}>
                  <div className={cx(styles.featuresImg)}>
                    <span className={cx(styles.icon, styles.iconChat)} />
                  </div>
                  <div className={cx(styles.cardBody, 'card-body')}>
                    <h3 className={cx(styles.cardTitle, ' card-title text-center')}>CHAT</h3>
                    <p className={cx(styles.cardText, 'card-text')}>
                      Can&apos;t find anything to do on the site, Zimidy makes it easy to connect
                      with people that want to do the same things as you, are in your same city, or
                      live nearby in your same zip code.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
            <div className={cx(styles.more, 'text-center')}>
              <p>And many available features in our app...</p>
            </div>
          </div>
        </div>

        <div className={cx(styles.event)}>
          <div className={cx(styles.bgEvent, 'container')}>
            <div className={cx(styles.interes, 'text-center')}>
              <h3 className={cx(styles.title)}>Interesting events</h3>
              <p className={cx(styles.desc)}>
                Find interesting events around your localion and enjoy!
              </p>
            </div>
            <Row className={cx(styles.groupItem)}>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className={cx(styles.item, styles.itemRight)}>
                  <div className={cx(styles.title)}>Shop 3 Secret Bargain Thrift Shops</div>
                  <div className={cx(styles.time)}>25 May 10:45PM - 30 May 10:00 AM</div>
                  <div className={cx(styles.desc)}>
                    <p>
                      Let the thrifting begin!! By the end of this 3-store secret thrift tour,
                      you&apos;ll have BAGS of bargain deals!!
                    </p>
                  </div>
                  <div className={cx(styles.hastag)}>#shopping</div>
                  <div className={cx(styles.selected)}>1</div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6}>
                <div className={cx(styles.item, styles.itemRight)}>
                  <div className={cx(styles.title)}>5Ls at New York!</div>
                  <div className={cx(styles.time)}>25 June 10:00PM - 28 June 07:00 AM</div>
                  <div className={cx(styles.desc)}>
                    <p>
                      Downtown, the best bit of Manhattan. One of, if not the, LARGEST space on
                      Airbnb in NYC.
                    </p>
                  </div>
                  <div className={cx(styles.hastag)}>#livingexperiences</div>
                  <div className={cx(styles.selected)}>2</div>
                </div>
              </Col>
            </Row>
            <Row className={cx(styles.groupItem)}>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className={cx(styles.item, styles.itemLeft)}>
                  <div className={cx(styles.title)}>Photoshoot with view at NY</div>
                  <div className={cx(styles.time)}>08 April 10:45PM - 12 April 10:00 AM</div>
                  <div className={cx(styles.desc)}>
                    <p>
                      I am a an Italian native Fashion Stylist and Instagram influencer based in New
                      York, I studied Fashion photography...
                    </p>
                  </div>
                  <div className={cx(styles.hastag)}>#photoshoot</div>
                  <div className={cx(styles.selected)}>3</div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6} className="bottom top left">
                <div className={cx(styles.item, styles.itemLeft)}>
                  <div className={cx(styles.title)}>The Country &amp the NYC Waterfront!</div>
                  <div className={cx(styles.time)}>25 April 10:45PM - 28 April 10:00 AM</div>
                  <div className={cx(styles.desc)}>
                    <p>
                      Superhosts are experienced, highly rated hosts who are committed to providing
                      great stays for guests.
                    </p>
                  </div>
                  <div className={cx(styles.hastag)}>#naturetravels</div>
                  <div className={cx(styles.selected)}>4</div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <footer className={cx(styles.footer, 'text-center')}>
          <ul className={cx(styles.list)}>
            <li className={cx(styles.item)}>
              <a href="#" className={cx(styles.link)}>
                Privacy Policy
              </a>
            </li>
            <li className={cx(styles.item)}>
              <a href="#" className={cx(styles.link)}>
                Report a problem
              </a>
            </li>
            <li className={cx(styles.item)}>
              <a href="#" className={cx(styles.link)}>
                Terms of Use
              </a>
            </li>
            <li className={cx(styles.item)}>
              <a href="#" className={cx(styles.link)}>
                Advertise Dream
              </a>
            </li>
            <li className={cx(styles.item)}>
              <a href="/" className={cx(styles.link)}>
                Why Zimidy ?
              </a>
            </li>
            <li className={cx(styles.item)}>
              <a href="/" className={cx(styles.link)}>
                FAQ
              </a>
            </li>
          </ul>
          <p className={cx(styles.license)}>Copyright © 2019 Zimidy LLC</p>
        </footer>
      </div>
    );
  }
}
